<template>
  <div class="notice-list mt20" v-if="isShow">
    <div class="title">{{ getworkDynamicsList.label }}</div>
    <div>
      <!-- style="display: flex;" -->
      <div class="imgLeft" v-if="getworkDynamicsList.left">
        <img :src="getworkDynamicsList.img" style="width: 100%; height: 100%" />
        <!-- <img
          class="btn"
          :src="getworkDynamicsList.btn"
          style="width: 140px;height: 40px;"
          @click="handleViewAll(getworkDynamicsList.source)"
        /> -->
        <div class="btn">
          <p class="btn-title">{{ getworkDynamicsList.left.title }}</p>
          <p class="btn-click" @click="handleOp(getworkDynamicsList.left)">
            立即查看>
          </p>
        </div>
      </div>
      <div v-else class="imgLeft"></div>
      <div class="right">
        <div class="workDynamics">
          <ul>
            <li
              v-for="item2 in getworkDynamicsList.list"
              class="ellipsis ccui-clearfix"
              :key="item2.id"
              @click="handleOp(item2)"
            >
              <p>{{ item2.title }}</p>
              <div class="img">
                <img :src="item2.imgUrl" alt="" />
              </div>
            </li>
            <li
              v-for="item2 in 6 - getworkDynamicsList.list.length"
              class="ellipsis ccui-clearfix"
              style="background-color: #f2f7fc"
              :key="item2"
            ></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <el-link
      :underline="false"
      type="info"
      class="notice-list-view-all"
      @click="handleViewAll(getworkDynamicsList.source)"
      >更多 ></el-link
    > -->
  </div>
</template>

<script>
import { updateAdvHits } from "../api/shopping";
export default {
  name: "noticeList",
  props: ["workDynamicsList"],
  data() {
    return {
      tabName: "first",
      nodeList: [],
      agentIdEncrypt: ""
    };
  },
  computed: {
    getworkDynamicsList() {
      return this.workDynamicsList;
    },
    isShow() {
      return (
        this.getworkDynamicsList.left ||
        this.getworkDynamicsList.list.length > 0
      );
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    handleOp(row) {
      if (row.linkUrl) {
        updateAdvHits({
          advInfoId: row.id
        });
        window.open(row.linkUrl, "_blank");
      }
    },
    handleViewAll() {
      // 跳转中交资源共享专区首页: clp.iccec.cn
      window.location.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_YZ_URL
      )}`;
    }
  }
};
</script>

<style scoped lang="scss">
.mt20 {
  margin-top: 4px;
}
.imgLeft {
  width: 232px;
  height: 376px;
  position: relative;
  float: left;
  margin-bottom: 20px;
  margin-right: 20px;
  cursor: pointer;
  .btn {
    position: absolute;
    left: 24px;
    bottom: 116px;
    .btn-title {
      width: 144px;
      height: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      color: #ffffff;
      margin-bottom: 10px;
    }
    .btn-cont {
      width: 117px;
      height: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 32px;
    }
    .btn-click {
      cursor: pointer;
      width: 90px;
      height: 32px;
      border: 1px solid #ffffff;
      border-radius: 4px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      margin-top: 10px;
    }
  }
}
.notice-list {
  // height: 240px;
  width: 100%;
  position: relative;
}
.title {
  width: 100%;
  height: 32px;
  font-size: 24px;
  font-weight: 500;
  font-family: PingFangSC, PingFang SC;
  margin-bottom: 16px;
  color: #4a4a4a;
}
.workDynamics {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  ul {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    // margin-left: 16px;
    li {
      cursor: pointer;
      width: 296px;
      height: 180px;
      margin-bottom: 20px;
      background: #ffffff;
      position: relative;
      p {
        position: absolute;
        top: 24px;
        left: 24px;
        height: 22px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #4a4a4a;
        text-align: left;
      }
      .img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 200px;
        height: 130px;
        margin-right: 0;
        margin-bottom: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
/deep/ .el-tabs__header {
  margin-bottom: 25px;
}
.icon-notice-list {
  position: absolute;
  left: 20px;
  top: 16px;
  color: #0089ef;
}
</style>
